<template>
  <div>
    <b-input-group class="autocomplete-input-group">
      <b-form-input
        id="input-worker-cost-type"
        size="sm"
        :disabled="this.$props.isDisabled"
        v-model="query"
        placeholder="Тип расхода"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"/>

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || this.$props.isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-worker-cost-type" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
          @mousedown="onClick(item)"
          button
        >
          {{ getItemListText(item) }}
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";

export default {
  name: "WorkerCostTypeSelect",
  mixins: [ catalogs ],
  props: {
    isDisabled: Boolean,
    id: Number
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      item: null
    }
  },
  methods: {
    async configure(id) {
      this.query = "";

      if (id > 0) {
        const worker_cost_type = (await this.getWorkerCostTypeById(id)).data;
        if (worker_cost_type != null) {
          this.query = worker_cost_type.name;
          this.item = worker_cost_type;
          return;
        }
      }

      this.items = await this.getItems(this.query);
    },
    async onFocusIn() {
      if (this.query === "" && this.items.length === 0) {
        this.items = await this.getItems(this.query);
      }
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect',null);
    },
    onClick(item) {
      this.query = item.name;
      this.item = item;
      this.$emit('onSelect', item);
    },
    getItemListText(item) {
      return item.name;
    },
    async getItems(query) {
      const result = await this.getWorkerCostTypesSearch(query);
      if (result.data != null) {
        return result.data;
      } else {
        return [];
      }
    }
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          const queryLower = this.query.toLowerCase();
          this.items = await this.getItems(queryLower);
        }
      },
      deep: true
    },
    'id': {
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.configure(newId);
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
/* Autocomplete Select Input */
.autocomplete-input-worker-cost-type {
  margin-top: 31px;
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
  text-align: left;
}

.autocomplete-input-group {
  position: unset;
}

/* Autocomplete Select Input Group Item */
.autocomplete-input-worker-cost-type .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerCostTypes/WorkerCostTypeSelect.vue